import * as React from 'react';
import { ArticleHeading4 } from '@cian/ui-kit';

import { IAvailableRating } from '../../types/rating';
import { RatingsFilterButton } from './RatingsFilterButton';
import * as style from './RatingsFilter.css';

export interface IRatingsFilterProps {
  availableRatings: IAvailableRating[];
  onFilterClick(reviewRate: number): void;
}

export const RatingsFilterComponent: React.FC<IRatingsFilterProps> = props => {
  const { availableRatings, onFilterClick } = props;

  return (
    <div className={style['container']}>
      <div className={style['title']}>
        <ArticleHeading4>Отзывы с оценкой</ArticleHeading4>
      </div>
      <ul className={style['stars']}>
        {availableRatings.map(({ reviewRate, reviewCount, checked }) => (
          <li key={reviewRate} className={style['stars-item']}>
            <RatingsFilterButton
              reviewRate={reviewRate}
              reviewCount={reviewCount}
              checked={checked}
              onClick={() => onFilterClick(reviewRate)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export const RatingsFilter = React.memo(RatingsFilterComponent);
